import React from 'react';
import {useState,useEffect,Component} from 'react';
import { useNavigate } from 'react-router-dom';
import { BrowserRouter as Router,Routes,Route,Link} from 'react-router-dom';
import moment from 'moment/moment';


import './Resources/dashboard.css';
import axios from '../axios.js';
import Navbar from './Supportingfiles/navbar.js';
import Sidebar from './Supportingfiles/sidebar';
//import Create_customers from './create_customers';
import {useRef as useref} from 'react';
import {useReactToPrint} from 'react-to-print';


import Chart from "chart.js/auto";
import { Line, Bar } from "react-chartjs-2";


//EXCEL DOWNLOAD IMPORT
//import * as XLSX from 'xlsx';
//import { saveAs } from 'file-saver';

function Employee_dashboard(){




    //Invoice Print Function
    const componentRef = useref();
    const handlePrint = useReactToPrint({
      content: () => componentRef.current,
    });
    
 //Checking Sessions
 // Access value associated with the login status
 const logstatus=sessionStorage.getItem("logStatus00");
 const logtype=sessionStorage.getItem("logType00");
 const logid=sessionStorage.getItem("logId00");
 const token=sessionStorage.getItem("logToken00");

 /* PAGE VARIABLES */





 
//Variables
const[data,setData] = useState([]);//SetData Variable


//ERROR VARIABLES 
const[error_msg,seterror_msg]=useState();


return(
    <>
<html lang="en">
  <head>
    {/*} Required meta tags */}
    <meta charset="utf-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
    <title>Pragati Prathmik Sakh Sahkari Samiti Maryadit | Employee Dashboard</title>
    {/*} plugins:css */}
    <link rel="stylesheet" href="panel/assets/vendors/mdi/css/materialdesignicons.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/flag-icon-css/css/flag-icon.min.css" />
    <link rel="stylesheet" href="panel/assets/vendors/css/vendor.bundle.base.css" />
    {/*} endinject */}
    {/*} Plugin css for this page */}
    <link rel="stylesheet" href="panel/assets/vendors/jquery-bar-rating/css-stars.css" />
    <link rel="stylesheet" href="panel/assets/vendors/font-awesome/css/font-awesome.min.css" />
    {/*} End plugin css for this page */}
    {/*} inject:css */}
    {/*} endinject */}
    {/*} Layout styles */}
    <link rel="stylesheet" href="panel/assets/css/demo_1/style.css" />
    {/*} End layout styles */}
    <link rel="shortcut icon" href="panel/assets/images/favicon.png" />
  </head>
  <body>
    <div className="container-scroller">

    <div className="container-fluid page-body-wrapper">


       <Navbar />
        {/*} partial */}
        <div className="main-panel">

        

          <div className="content-wrapper pb-0">

          <div className="row">
              <div className="col-12 grid-margin create-form" id="create-form">
             {/*} <Create_cash /> */}
              </div>
          </div>


            <div className="page-header flex-wrap">
            <div className="header-left">  
           
            </div>
              <div className="header-right d-flex flex-wrap mt-2 mt-sm-0">
                <div className="d-flex align-items-center">
                  <a href="#">
                    <p className="m-0 pe-3">EMPLOYEE PANEL</p>
                  </a>
                  <a className="ps-3 me-4" href="#">
                    <p className="m-0">DASHBOARD</p>
                  </a>
                </div>
             {/*}   <button type="button" className="btn btn-primary mt-2 mt-sm-0 btn-icon-text"  onClick={()=>{ 
               const createForm = document.getElementById('create-form');
               const currentDisplay = createForm.style.display;
               createForm.style.display = currentDisplay === 'none' ? 'block' : 'none'; }}>
                  <i className="mdi mdi-plus-circle"></i> </button> */}
              </div>
            </div>

            {/*} chart row starts here */}
            <div className="row">

          
            </div>

             {/* TOP BAR 
               <div class="row">
             
                <div class="card card-stat stretch-card mb-3">
                  <div class="card-body col-md-4">
                    <div class="d-flex justify-content-between">
                      <div class="text-white" style={{textAlign:"left"}}>
                        <h3 class="font-weight-bold mb-0">₹ 7000.00</h3>
                        <h6>Order Value</h6>
                        <div class="badge badge-success">+ ₹ 450</div>
                      </div>
                      <div class="flot-bar-wrapper">
                        <div id="column-chart" class="flot-chart"></div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="card stretch-card mb-3 col-md-3" style={{textAlign:"left"}}>
                  <div class="card-body d-flex flex-wrap justify-content-between">
                    <div>
                      <h4 class="font-weight-semibold mb-1 text-black"> My Orders </h4>
                      <h6 class="text-muted">all orders made</h6>
                    </div>
                    <h3 class="text-primary font-weight-bold">75</h3>
                  </div>
                </div>
                <div class="card stretch-card mb-3 col-md-3" style={{textAlign:"left"}}>
                  <div class="card-body d-flex flex-wrap justify-content-between">
                    <div>
                      <h4 class="font-weight-semibold mb-1 text-black"> Pickups </h4>
                      <h6 class="text-muted">pickup requests</h6>
                    </div>
                    <h3 class="text-primary font-weight-bold">50</h3>
                  </div>
                </div>
                <div class="card mb-3 col-md-3" style={{textAlign:"left"}}>
                  <div class="card-body d-flex flex-wrap justify-content-between">
                    <div>
                      <h4 class="font-weight-semibold mb-1 text-black"> My Trainings </h4>
                      <h6 class="text-muted">all trainings enrolled</h6>
                    </div>
                    <h3 class="text-primary font-weight-bold">50</h3>
                  </div>
                </div>
                <div class="card mb-3 col-md-3" style={{textAlign:"left"}}>
                  <div class="card-body d-flex flex-wrap justify-content-between">
                    <div>
                      <h4 class="font-weight-semibold mb-1 text-black"> Payments </h4>
                      <h6 class="text-muted">all payments</h6>
                    </div>
                    <h3 class="text-primary font-weight-bold">500</h3>
                  </div>
                </div>

              </div>
             

            {/* DASHBOARD SECTION START */}
            <div class="row">

                 
              {/* Card 1 Start */}
              <div class="col-sm-4 stretch-card grid-margin">
              <div class="card">
                  <div class="card-body p-0" style={{borderBottom:"0.2rem solid #0c4489"}}>
                   <img src="https://cdn.vectorstock.com/i/500p/33/95/man-using-pc-login-concept-vector-38203395.avif" style={{maxHeight:"40vh", minHeight:"40vh"}} class="img-fluid w-100"  alt="Image" /> 
                  </div>
                  <div class="card-body px-3 text-dark">
                   {/*} <div class="d-flex justify-content-between">
                      <p class="text-muted font-13 mb-0">My Profile</p>
                      <button class="btn btn-primary">Manage Profile</button>
                    </div> */}
                    <h5 class="font-weight-semibold" style={{textAlign:"left"}}>CUSTOMERS AND LOAN APPLICATIONS</h5>
                    <p style={{textAlign:"left"}}>manage customers and loans</p>

                    <div class="row">
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",1);
                      window.location.href="/employee-dashboard-customers";
                    }}>Customers</button></p>
                     <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",1);
                      window.location.href="/employee-dashboard-new-account-requests";
                    }}> New Account Requests</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",1);
                      window.location.href="/employee-dashboard-loan-payments";
                    }}>Loan EMIs</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",1);
                      window.location.href="/employee-dashboard-loan-requests";
                    }}>Loan Requests</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",1);
                      window.location.href="/employee-dashboard-loan-disbursals";
                    }}>Loan Disbursals</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",1);
                      window.location.href="/employee-dashboard-partpayment-requests";
                    }}>Partpayment Requests</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",1);
                      window.location.href="/employee-dashboard-loan-closure-requests";
                    }}>Loan Closure Requests</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",1);
                      window.location.href="/employee-dashboard-loan-groups";
                    }}>Loan Groups</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",1);
                      window.location.href="/employee-dashboard-loan-schemes";
                    }}>Loan Schemes</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",1);
                      window.location.href="/employee-dashboard-topup-loanclosure-requests";
                    }}>Topup Loan - Closures</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",1);
                      window.location.href="/employee-dashboard-topup-loan-requests";
                    }}>Topup Loan - Requests</button></p>
                    </div>



                   {/*} <div class="d-flex justify-content-between font-weight-semibold">
                    <button type="submit" class="btn btn-outline-primary mb-0">view</button>
                    <p class="mb-0 text-info"><b>₹ 50000</b></p>
                    </div> */}
                  </div>
                </div>
              </div>     
              {/* Card 1 End */}

              {/* Card 2 Start */}
              <div class="col-sm-4 stretch-card grid-margin">
              <div class="card">
                  <div class="card-body p-0" style={{borderBottom:"0.2rem solid #0c4489"}}>
                   <img src="https://cdn.vectorstock.com/i/500p/93/18/investment-statistic-growth-with-money-cartoon-vector-46429318.avif" style={{maxHeight:"40vh", minHeight:"40vh"}} class="img-fluid w-100"  alt="Image" /> 
                  </div>
                  <div class="card-body px-3 text-dark">
                   {/*} <div class="d-flex justify-content-between">
                      <p class="text-muted font-13 mb-0">My Profile</p>
                      <button class="btn btn-primary">Manage Profile</button>
                    </div> */}
                    <h5 class="font-weight-semibold" style={{textAlign:"left"}}>CASH AND OTHERS</h5>
                    <p style={{textAlign:"left"}}>manage cash, bank, incomes and expenses</p>
                 
                    <div class="row">
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",2);
                      window.location.href="/employee-dashboard-cash";
                    }}>Cash</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",2);
                      window.location.href="/employee-dashboard-bank";
                    }}>Bank</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",2);
                      window.location.href="/employee-dashboard-incomes";
                    }}>Incomes</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",2);
                      window.location.href="/employee-dashboard-expenses";
                    }}>Expenses</button></p>
                    </div>

                  </div>
                </div>
              </div>     
              {/* Card 2 End */}

              {/* Card 3 Start */}
              <div class="col-sm-4 stretch-card grid-margin">
              <div class="card">
                  <div class="card-body p-0" style={{borderBottom:"0.2rem solid #0c4489"}}>
                   <img src="https://cdn.vectorstock.com/i/500p/01/85/training-courses-isometric-icons-vector-23210185.avif"  style={{maxHeight:"40vh", minHeight:"40vh"}} class="img-fluid w-100"  alt="Image" /> 
                  </div>
                  <div class="card-body px-3 text-dark">
                   {/*} <div class="d-flex justify-content-between">
                      <p class="text-muted font-13 mb-0">My Profile</p>
                      <button class="btn btn-primary">Manage Profile</button>
                    </div> */}
                    <h5 class="font-weight-semibold" style={{textAlign:"left"}}>SUMMARY</h5>
                    <p style={{textAlign:"left"}}>manage summaries</p>
                    <div class="row">
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",3);
                      window.location.href="/employee-dashboard-transaction-history";
                    }}>Transaction History</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",3);
                      window.location.href="/employee-dashboard-customer-updations";
                    }}>Customer History</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",3);
                      window.location.href="/employee-dashboard-update-adr-number";
                    }}>Update Customer Adr</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",3);
                      window.location.href="/employee-final-analysis";
                    }}>Summary</button></p>
                     <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",3);
                      window.location.href="/employee-dashboard-daysummarylist";
                    }}>Day Summary</button></p>
                    </div>

                  </div>
                </div>
              </div>     
              {/* Card 3 End */}

              {/* Card 4 Start */}
              <div class="col-sm-4 stretch-card grid-margin">
              <div class="card">
                  <div class="card-body p-0" style={{borderBottom:"0.2rem solid #0c4489"}}>
                   <img src="https://cdn.vectorstock.com/i/500p/38/85/hourglass-with-plant-of-money-and-gold-coin-vector-46473885.avif" class="img-fluid w-100"  style={{maxHeight:"40vh", minHeight:"40vh"}}  alt="Image" /> 
                  </div>
                  <div class="card-body px-3 text-dark">
                    <h5 class="font-weight-semibold" style={{textAlign:"left"}}>Fixed Deposit(FD) Management</h5>
                    <p style={{textAlign:"left"}}>manage Fixed Deposits (FD) </p>
                
                     <div class="row">
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",4);
                      window.location.href="/employee-dashboard-fd-schemes";
                    }}>FD Schemes</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",4);
                      window.location.href="/employee-dashboard-fd-requests";
                    }}>FD Requests</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",4);
                      window.location.href="/employee-dashboard-fixed-deposits";
                    }}>Fixed Deposits (FDs)</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",4);
                      window.location.href="/employee-dashboard-fd-withdrawals";
                    }}>FD Withdrawals</button></p>
                    </div>



                  </div>
                </div>
              </div>     
              {/* Card 4 End */}

              {/* Card 5 Start */}
              <div class="col-sm-4 stretch-card grid-margin">
              <div class="card">
                  <div class="card-body p-0" style={{borderBottom:"0.2rem solid #0c4489"}}>
                   <img src="https://cdn.vectorstock.com/i/500p/93/38/invesment-plant-money-with-gold-coin-cartoon-vector-46429338.avif" class="img-fluid w-100"  style={{maxHeight:"40vh", minHeight:"40vh"}}  alt="Image" /> 
                  </div>
                  <div class="card-body px-3 text-dark">
                  
                    <h5 class="font-weight-semibold" style={{textAlign:"left"}}>Recurring Deposit(RD) Requests</h5>
                    <p style={{textAlign:"left"}}>manage Recurring Deposits(RD)</p>
                    <div class="row">
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",5);
                      window.location.href="/employee-dashboard-rd-schemes";
                    }}>RD Schemes</button></p>
                     <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",5);
                      window.location.href="/employee-dashboard-rd-requests";
                    }}>RD Requests</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",5);
                      window.location.href="/employee-dashboard-recurring-deposits";
                    }}>Recurring Deposits</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",5);
                      window.location.href="/employee-dashboard-rd-installment-payments";
                    }}>RD Installments</button></p>
                    <p class="col-md-6" style={{textAlign:"left"}}><button class="btn btn-outline-primary" style={{ width:"100%"}} onClick={()=>{
                      sessionStorage.setItem("Dash00",5);
                      window.location.href="/employee-dashboard-rd-withdrawals";
                    }}>RD Withdrawals</button></p>

                    </div>
      


                  </div>
                </div>
              </div>     
              {/* Card 5 End */}

       
            </div>
          {/* DASHBOARD SECTION END */}
          


           <br/><br/><br/>
            
          </div>
          {/*} content-wrapper ends */}
          {/*} partial:partials/_footer.html */}
       {/*}   <footer className="footer">
            <div className="d-sm-flex justify-content-center justify-content-sm-between">
              <span className="text-muted text-center text-sm-left d-block d-sm-inline-block">Copyright © 2021 <a href="https://www.bootstrapdash.com/" target="_blank">BootstrapDash</a>. All rights reserved.</span>
              <span className="float-none float-sm-right d-block mt-1 mt-sm-0 text-center">Hand-crafted & made with <i className="mdi mdi-heart text-danger"></i></span>
            </div>
          </footer> */}
          {/*} partial */}
        </div>
        {/*} main-panel ends */}
      </div>
      {/*} page-body-wrapper ends */}
    </div>
    {/*} container-scroller */}
    {/*} plugins:js */}
    <script src="panel/assets/vendors/js/vendor.bundle.base.js"></script>
    {/*} endinject */}
    {/*} Plugin js for this page */}
    <script src="panel/assets/vendors/jquery-bar-rating/jquery.barrating.min.js"></script>
    <script src="panel/assets/vendors/chart.js/Chart.min.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.resize.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.categories.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.fillbetween.js"></script>
    <script src="panel/assets/vendors/flot/jquery.flot.stack.js"></script>
    <script src="panel/assets/js/jquery.cookie.js" type="text/javascript"></script>
    {/*} End plugin js for this page */}
    {/*} inject:js */}
    <script src="panel/assets/js/off-canvas.js"></script>
    <script src="panel/assets/js/hoverable-collapse.js"></script>
    <script src="panel/assets/js/misc.js"></script>
    <script src="panel/assets/js/settings.js"></script>
    <script src="panel/assets/js/todolist.js"></script>
    {/*} endinject */}
    {/*} Custom js for this page */}
    <script src="panel/assets/js/dashboard.js"></script>
    {/*} End custom js for this page */}
  </body>
</html>
</>
);

//}
}
export default Employee_dashboard;